/* eslint-disable no-nested-ternary */
import React, { memo, ReactElement, useCallback, useEffect, useMemo } from 'react';

import { Row } from '@components/atoms';
import { useReduxForm } from '@hooks/useReduxForm';
import { moveFocus } from '@utils/dataUtils';
import { getSurveyObj } from '@utils/surveyUtils';
import moment from 'moment';

function Date({ formKey }: { formKey: string }): ReactElement {
  const { formData, setFormData } = useReduxForm('survey');

  const surveyObj = useMemo(() => getSurveyObj(formKey), [formKey]);

  useEffect(() => {
    if (!formData[formKey] && surveyObj?.defaultDate) {
      setFormData({
        [formKey]: surveyObj?.defaultDate,
        [`${formKey}Next`]: 0,
      });
    }
    moveFocus(`date-input-${formKey}`);
  }, [formKey]);

  return (
    <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
      <input
        autoComplete="off"
        id={`date-input-${formKey}`}
        max={moment().format('YYYY-MM-DD')}
        onChange={(e) => {
          const { value } = e.target;
          setFormData({
            [formKey]: value,
            [`${formKey}Next`]: 0,
          });
        }}
        style={{
          border: '1px solid #d9d9d9',
          borderRadius: '4px',
          width: '200px',
          height: '50px',
          fontSize: '16px',
          lineHeight: '1em',
          paddingInline: '15px',
          paddingTop: '4px',
        }}
        type="date"
        value={formData[formKey]}
      />
    </Row>
  );
}

export default memo(Date);
